import React from 'react'
import Button from '../../../../designSystem/Buttons/Index'


const SupportProgramSection = () => {
  return (
    <div className='tl-support-program-section' data-aos="fade-up">
        <div className="tl-support-program-left-right-container">
            <div className="tl-support-program-section-left">

            </div>
            <div className="tl-support-program-section-right">
                <h1>Un programa de soporte integral y continuo</h1>
                <div className="tl-advantages-container">
                    <div className="tl-advantage-block">
                        <h3>Asesoría</h3>
                        <ul>
                            <li>Asesoría psicológica para las dificultades de la vida: duelos, separaciones, soporte a hijos.</li>
                            <li>Asesoría nutricional para mejorar los hábitos y lograr metas.</li>
                            <li>Asesoría financiera para las decisiones importantes: créditos, hipotecas, planificación a futuro.</li>
                        </ul>
                    </div>
                    <div className="tl-advantage-block">
                        <h3>Terapia</h3>
                        <ul>
                            <li>Terapia psicológica para la ansiedad, estrés, depresión, problemas de sueño, adicciones, entre muchos otros.</li>
                            <li>Terapia multidisciplinaria para trastornos alimentarios.</li>
                            <li>Recomendaciones de tratamientos psicofarmacológicos cuando sea necesario.</li>
                        </ul>
                    </div>
                    <div className="tl-advantage-block">
                        <h3>Soporte a la familia</h3>
                        <ul>
                            <li>Terapia para los familiares de tus colaboradores.</li>
                            <li>Terapia de familias y parejas para tus colaboradores.</li>
                            <li>Asesoría sobre problemas de los hijos en la escuela.</li>
                        </ul>
                    </div>
                    <div className="tl-advantage-block">
                        <h3>Planes de aprendizaje</h3>
                        <ul>
                            <li>Aprendizaje y superación personal a través de programas autodirigidos para superar la ansiedad, mejorar los hábitos alimenticios, educación financiera, entre otros.</li>
                        </ul>
                    </div>
                    <div className="tl-advantage-block">
                        <h3>Terapia de grupos</h3>
                        <ul>
                            <li>Terapia de grupo para problemas en los grupos humanos de tu empresa.</li>
                            <li>Programas de bienestar nutricional grupal institucionales.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default SupportProgramSection